import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { EquiposComponent } from 'app/components/servicio-medico/despacho/subdespacho/equipos/equipos.component';

@Component ({
  selector: 'app-agregar-conductor',
  templateUrl: './agregar-conductor.component.html',
  styleUrls: ['./agregar-conductor.component.scss']
})
export class AgregarConductorComponent implements OnInit {

  public conductores;
  public conductor;

  constructor(private servicios:ServiciosService,
              public dialogRef: MatDialogRef<EquiposComponent>,
              @Inject(MAT_DIALOG_DATA) private datos,
              private snack: MatSnackBar) { }

  ngOnInit() {
    this.servicios.conductores().subscribe((data)=>{
      this.conductores = data;
      console.log(data);
    })
  }

  enviar(){
    if (this.conductor == null || this.conductor == undefined || this.conductor == "" ) {
      this.snack.open('Elija un conductor', '', {
          duration: 2000,
          panelClass: 'red-bg'
        })
    } else {
        console.log(this.conductor,"-",this.datos.movil);
      this.servicios.agregarConductor(this.conductor.Cod_Con, this.datos.movil).subscribe((data)=>{
          console.log(data);
      });
      this.dialogRef.close(this.conductor.Conductor);
    }
  }

}
